{
  "localeInternationalCountryCode": "CN",
  "PhoneInput": {
    "placeholder": "输入电话号码",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "选择国家",
    "emptyCountries": "未找到国家",
    "emptyDisplay": "-",
    "groupCommon": "常用",
    "groupAllCountries": "所有国家"
  },
  "VersionSwitch": {
    "ariaLabel": "版本",
    "beta": "测试版",
    "new": "新版",
    "classic": "经典版",
    "switchBackAnytime": "可随时切换回来",
    "sendFeedback": "发送反馈",
    "feedbackDraft": "{{feature}} – 反馈：",
    "switchedToNew": "已切换到新版",
    "switchedToClassic": "已切换到经典版",
    "undo": "撤销"
  }
}
